import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import jsPDF from 'jspdf';
import styles from './HowToUseSayingModal.module.css';
import { X, Download, ArrowLeft, ArrowRight } from '../common/Icons';
import { useAuth } from '../../shared/contexts/AuthContext';

const HowToUseSayingModal = ({ isOpen, onClose, onRequireLogin }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const { isAuthenticated } = useAuth();

  if (!isOpen) return null;

  const images = [
    { url: '/assets/images/contents/dailySaying/dailySaying_class_paper.webp', name: '오늘의명언_활동지(양식).pdf' },
    { url: '/assets/images/contents/dailySaying/dailySaying_class_example_paper.webp', name: '오늘의명언_활동지(예시).pdf' }
  ];

  const currentImage = images[currentIndex];

  const goToPrevious = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  const goToNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  const handleDownload = () => {
    if (!isAuthenticated) {
      onClose(); // 현재 모달을 닫고
      onRequireLogin(); // 부모에게 로그인 안내 모달을 열도록 요청
      return;
    }

    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => {
      const pdf = new jsPDF('p', 'mm', 'a4');
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      
      const imgProps= pdf.getImageProperties(img);
      const imgAspectRatio = imgProps.width / imgProps.height;
      
      let finalImgWidth = pdfWidth - 20; // A4 여백 10mm
      let finalImgHeight = finalImgWidth / imgAspectRatio;

      if (finalImgHeight > pdfHeight - 20) {
        finalImgHeight = pdfHeight - 20;
        finalImgWidth = finalImgHeight * imgAspectRatio;
      }

      const x = (pdfWidth - finalImgWidth) / 2;
      const y = (pdfHeight - finalImgHeight) / 2;

      pdf.addImage(img, 'WEBP', x, y, finalImgWidth, finalImgHeight);
      pdf.save('오늘의명언_활동지(양식).pdf');
    };
    img.src = images[0].url; // 항상 첫 번째 이미지(양식)를 다운로드
  };

  return ReactDOM.createPortal(
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContent} onClick={e => e.stopPropagation()}>
        <button className={styles.closeButton} onClick={onClose}>
          <X size={24} />
        </button>
        <h2 className={styles.title}>명언 활동지 활용 예시</h2>
        <p className={styles.description}>
          오늘 뽑은 명언을 활동지에 적고, 그 의미를 생각하며 자신의 다짐을 써보는 활동으로 활용해 보세요.
        </p>
        <div className={styles.imageContainer}>
          <button onClick={goToPrevious} className={`${styles.arrowButton} ${styles.left}`}>
            <ArrowLeft size={24} />
          </button>
          <img src={currentImage.url} alt="명언 활용 예시" className={styles.image} />
          <button onClick={goToNext} className={`${styles.arrowButton} ${styles.right}`}>
            <ArrowRight size={24} />
          </button>
        </div>
        <button className={styles.downloadButton} onClick={handleDownload}>
          <Download size={18} />
          활동지 양식 PDF로 받기
        </button>
      </div>
    </div>,
    document.body
  );
};

export default HowToUseSayingModal;
